var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Dashboard"}},[_c('Stats'),_c('Charts',{staticClass:"mt-5 mb-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }